export default {
  baseStyle: {
    border: 'none',
    bg: 'none',
    _hover: {
      cursor: 'pointer',
    },
  },
}
